import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';

export function SnappingUnderlayMenu(props: { guid: string }) {
  return (
    <SceneMenuContent>
      <DeleteMenuItem type="snappingUnderlay" item={{ type: 'snappingUnderlay', guid: props.guid }} />
    </SceneMenuContent>
  );
}
